import { render, staticRenderFns } from "./get_competency.vue?vue&type=template&id=b9c8f8ac&scoped=true&"
import script from "./get_competency.vue?vue&type=script&lang=js&"
export * from "./get_competency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c8f8ac",
  null
  
)

export default component.exports